module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"msg-open-dialogs":"Sie haben einen offenen Dialog | Sie haben <b>{counter}</b> offene Dialoge"},"fr":{"msg-open-dialogs":"Vous avez un dialogue ouvert | Vous avez { <b>{counter}</b> dialogues ouverts"},"it":{"msg-open-dialogs":"Lei ha una finestra dialogo aperta | Lei ha <b>{counter}</b> finestre di dialogo aperte"}}')
  delete Component.options._Ctor
}
